import { actions as actions$1, SagaRegistry } from '@grandvision/state';
import Cookie from 'js-cookie';
import { isArray, getNestedProperty, getAttrValue, isPlainObject, getLocalizedValue, getLocalizedValues, QueryString, StringGuard, formatHour, getLocalizedAttrValue, useLocalStorage } from '@grandvision/utils';
import { takeLatest, call, all } from 'redux-saga/effects';
import { CommerceToolsApi } from '@grandvision/commercetools';
import React__default, { createElement, Fragment, Component } from 'react';
import ReactGA from 'react-ga';
import gtmParts from 'react-google-tag-manager';
import { constrain, Type, Constraint, either, verify } from 'specified';
import { version } from '@sentry/browser/package.json';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { connectStateResults } from 'react-instantsearch-core';

//https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/click-through-and-conversions/in-depth/clicks-conversions-best-practices/#how-to-name-your-events
var AlgoliaAnalyticsEvents;
(function (AlgoliaAnalyticsEvents) {
    AlgoliaAnalyticsEvents["SearchSuggestionClicked"] = "Search Suggestion Clicked";
    AlgoliaAnalyticsEvents["SearchResultClicked"] = "Search Result Clicked";
    AlgoliaAnalyticsEvents["ProductDetailCTAClicked"] = "Product Detail CTA Clicked";
})(AlgoliaAnalyticsEvents || (AlgoliaAnalyticsEvents = {}));
var AlgoliaEventType;
(function (AlgoliaEventType) {
    AlgoliaEventType["Conversion"] = "convertedObjectIDs";
    AlgoliaEventType["ConversionAfterSearch"] = "convertedObjectIDsAfterSearch";
    AlgoliaEventType["Click"] = "clickedObjectIDs";
    AlgoliaEventType["ClickAfterSearch"] = "clickedObjectIDsAfterSearch";
})(AlgoliaEventType || (AlgoliaEventType = {}));

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get AlgoliaAnalyticsEvents () { return AlgoliaAnalyticsEvents; },
  get AlgoliaEventType () { return AlgoliaEventType; }
});

var getVisitorId = function () {
    var visitorId = Cookie.get('_visitor');
    if (!visitorId) {
        return Cookie.get('_ALGOLIA'); // use the fallback usertoken provided by algolia
    }
    return visitorId;
};
var clickedObjectIds = function (eventData) {
    var algoliaAnalyticsHandler = getAlgoliaAnalyticsHandler();
    var objectIds = eventData.objectIds, searchIndex = eventData.searchIndex, eventName = eventData.eventName;
    if (algoliaAnalyticsHandler) {
        algoliaAnalyticsHandler(AlgoliaEventType.Click, {
            userToken: getVisitorId(),
            objectIDs: isArray(objectIds) ? objectIds : [objectIds],
            index: searchIndex,
            eventName: eventName,
        });
    }
};
var handleConversionEvent = function (eventData) {
    var algoliaAnalyticsHandler = getAlgoliaAnalyticsHandler();
    var objectIds = eventData.objectIds, searchIndex = eventData.searchIndex, queryId = eventData.queryId;
    var visitorId = getVisitorId();
    if (!visitorId) {
        return;
    }
    if (algoliaAnalyticsHandler && searchIndex && objectIds) {
        var eventData_1 = {
            userToken: visitorId,
            index: searchIndex,
            queryID: queryId,
            eventName: AlgoliaAnalyticsEvents.ProductDetailCTAClicked,
            objectIDs: Array.isArray(objectIds) ? objectIds : [objectIds],
        };
        var type = eventData_1.queryID
            ? AlgoliaEventType.ConversionAfterSearch
            : AlgoliaEventType.Conversion;
        algoliaAnalyticsHandler(type, eventData_1);
    }
};
var clickedObjectIdsAfterSearch = function (eventData) {
    var algoliaAnalyticsHandler = getAlgoliaAnalyticsHandler();
    var searchIndex = eventData.searchIndex, positions = eventData.positions, objectIds = eventData.objectIds, eventName = eventData.eventName, queryId = eventData.queryId;
    if (!positions || !objectIds) {
        console.warn('Algolia analytics event could not be sent! eventData:', eventData);
        return;
    }
    if (algoliaAnalyticsHandler) {
        algoliaAnalyticsHandler(AlgoliaEventType.ClickAfterSearch, {
            eventName: eventName,
            queryID: queryId,
            objectIDs: isArray(objectIds) ? objectIds : [objectIds],
            positions: isArray(positions) ? positions : [positions],
            index: searchIndex,
            userToken: getVisitorId(),
        });
    }
};
var getAlgoliaAnalyticsHandler = function () {
    if (typeof window !== undefined && window.aa) {
        return window.aa;
    }
    return undefined;
};

var AlgoliaAnalyticsHelpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getVisitorId: getVisitorId,
  clickedObjectIds: clickedObjectIds,
  handleConversionEvent: handleConversionEvent,
  clickedObjectIdsAfterSearch: clickedObjectIdsAfterSearch,
  getAlgoliaAnalyticsHandler: getAlgoliaAnalyticsHandler
});

var pushEvent = actions$1.action('analytics/data-layer/push-event', function (payload) {
    return { payload: payload };
});

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  pushEvent: pushEvent
});

function pushEvent$1(event) {
    if (typeof window === 'undefined') {
        return;
    }
    if (!Array.isArray(window.dataLayer)) {
        window.dataLayer = [];
    }
    window.dataLayer.push(event);
}



var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Actions: actions,
  pushEvent: pushEvent$1
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function onPushEvent(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            /**
             * We copy the payload object here so GTM doesn't mutate it by adding a "gtm.uniqueEventId" property
             * onto it. This property will be added onto every GTM event, but we don't need it added onto our action payload.
             */
            return [4 /*yield*/, call(pushEvent$1, __assign({}, action.payload))];
            case 1:
                /**
                 * We copy the payload object here so GTM doesn't mutate it by adding a "gtm.uniqueEventId" property
                 * onto it. This property will be added onto every GTM event, but we don't need it added onto our action payload.
                 */
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var dataLayerSagas = [takeLatest(pushEvent.type, onPushEvent)];

function sagas () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all(__spread(dataLayerSagas))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

// Utilities

var ldJson = /*#__PURE__*/Object.freeze({
  __proto__: null
});

var ActionType;
(function (ActionType) {
    ActionType["Action"] = "Action";
    ActionType["Add"] = "AddAction";
    ActionType["Delete"] = "DeleteAction";
    ActionType["Reserve"] = "ReserveAction";
    ActionType["Subscribe"] = "SubscribeAction";
    ActionType["Search"] = "SearchAction";
    ActionType["UnRegister"] = "UnRegisterAction";
})(ActionType || (ActionType = {}));

var getUrlInfo = function (lineItem) {
    var productType = lineItem.productType, productSlug = lineItem.productSlug, sku = lineItem.variant.sku;
    var productTypeName = getNestedProperty(productType, 'obj.name', '');
    return {
        productType: productTypeName || '',
        slug: productSlug || '',
        sku: sku || '',
    };
};
var getPaymentMethodUrl = function (paymentMethod) {
    switch (paymentMethod) {
        case 'creditcard':
            return 'http://purl.org/goodrelations/v1#CreditCard';
        case 'paypal':
            return 'http://purl.org/goodrelations/v1#PayPal';
        default:
            return '';
    }
};
var priceVatCalc = function (price, rate) {
    var priceExVat = price / (1 + rate);
    var vatAmount = priceExVat * rate;
    return {
        priceExVat: priceExVat,
        vatAmount: vatAmount,
    };
};
var calcPrice = function (centAmount) {
    var price = !isNaN(centAmount) ? (centAmount / 100).toFixed(2).toString() : '0.00';
    if (price === '0') {
        return '0.00';
    }
    return price;
};
var createOfferObject = function (lineItem, quantity) {
    var activeVariant = lineItem.variant;
    var vat = getNestedProperty(lineItem, 'taxRate.amount', 0);
    return {
        '@type': 'Offer',
        includesObject: {
            '@type': 'TypeAndQuantityNode',
            amountOfThisGood: quantity || 1,
        },
        priceSpecification: createPriceSpecification(activeVariant, vat),
    };
};
var convertAttributeToLowerCase = function (attribute) {
    return Array.isArray(attribute) ? attribute.join().toLowerCase() : attribute.toLowerCase();
};
var createProductObject = function (lineItem, quantity, formatProductUrl, selfUrl) {
    var urlInfo = getUrlInfo(lineItem);
    var url = selfUrl || (window.location && window.location.origin) || '';
    if (formatProductUrl && urlInfo) {
        url += formatProductUrl(urlInfo);
    }
    var variant = lineItem.variant, productId = lineItem.productId, name = lineItem.name;
    var modelObj = getAttrValue(variant, 'frameShape');
    var model = isPlainObject(modelObj) ? getLocalizedValue(modelObj) : '';
    var frameMaterialAttr = getAttrValue(variant, 'frameMaterial');
    var frameMaterial = isPlainObject(frameMaterialAttr) ? getLocalizedValue(frameMaterialAttr) : '';
    var frameMaterials = Array.isArray(frameMaterialAttr)
        ? getLocalizedValues(frameMaterialAttr)
        : '';
    var frameColorAttr = getAttrValue(variant, 'frameColor');
    var frameColor = isPlainObject(frameColorAttr) ? getLocalizedValue(frameColorAttr) : '';
    var frameColors = isArray(frameColorAttr) ? getLocalizedValues(frameColorAttr) : '';
    return {
        '@type': 'Product',
        '@id': url + "#product",
        url: url,
        model: model,
        name: name.en || '',
        productID: productId || '',
        gtin13: variant.sku || urlInfo.sku || '',
        category: urlInfo.productType || '',
        brand: String(getAttrValue(variant, 'brand')),
        material: convertAttributeToLowerCase(frameMaterials || frameMaterial),
        color: convertAttributeToLowerCase(frameColor || frameColors),
        offers: [createOfferObject(lineItem, quantity)],
    };
};
var createPrescriptionGlassesObject = function (lineItem, formatProductUrl, selfUrl) {
    var _a = lineItem.bundleMainLineItem, name = _a.name, productId = _a.productId, brand = _a.brand, variant = _a.variant, productType = _a.productType, slug = _a.slug;
    var url = selfUrl || (window.location && window.location.origin) || '';
    if (formatProductUrl) {
        url += formatProductUrl({
            sku: variant.sku,
            productType: productType,
            slug: slug,
        });
    }
    return {
        '@type': 'Product',
        '@id': url + "#product",
        url: url,
        brand: brand,
        name: name.en || '',
        sku: variant.sku || '',
        gtin13: variant.sku || '',
        productID: productId || '',
        category: 'Optical',
        offers: [createPrescriptionGlassesOffer(lineItem)],
    };
};
var createPrescriptionGlassesOffer = function (_a) {
    var quantity = _a.quantity, price = _a.price, bundleMainLineItem = _a.bundleMainLineItem;
    return ({
        '@type': 'Offer',
        includesObject: {
            '@type': 'TypeAndQuantityNode',
            amountOfThisGood: quantity || 1,
        },
        priceSpecification: createPrescriptionGlassesPrice(price, bundleMainLineItem.taxRate),
    });
};
var createPrescriptionGlassesPrice = function (price, taxRate) {
    var _a, _b;
    var resolvedPrice = (_b = (_a = price.discounted) === null || _a === void 0 ? void 0 : _a.value.centAmount) !== null && _b !== void 0 ? _b : price.value.centAmount;
    var resolvedPriceExVat = resolvedPrice * (1 - taxRate.amount);
    var resolvedVatAmount = resolvedPrice * taxRate.amount;
    return {
        '@type': 'CompoundPriceSpecification',
        name: 'Price',
        price: calcPrice(resolvedPrice),
        priceCurrency: price.value.currencyCode,
        valueAddedTaxIncluded: true,
        priceComponent: [
            {
                '@type': 'UnitPriceSpecification',
                name: 'Price excluding VAT',
                price: calcPrice(resolvedPriceExVat),
                valueAddedTaxIncluded: false,
            },
            {
                '@type': 'UnitPriceSpecification',
                name: 'VAT',
                price: calcPrice(resolvedVatAmount),
                valueAddedTaxIncluded: true,
            },
        ],
    };
};
var createOrderObject = function (order, paymentMethod, formatProductUrl, selfUrl) {
    var lineItems = order.lineItems, _a = order.prescriptionGlassesLineItems, prescriptionGlassesLineItems = _a === void 0 ? [] : _a, orderNumber = order.orderNumber, totalPrice = order.totalPrice, shippingInfo = order.shippingInfo;
    var originalTotal = __spread(lineItems, prescriptionGlassesLineItems).reduce(function (total, currentValue) { return (total += currentValue.price.value.centAmount * currentValue.quantity); }, 0);
    var shippingCost = shippingInfo && shippingInfo.price ? shippingInfo.price.centAmount : 0;
    var discountTotal = originalTotal - totalPrice.centAmount + shippingCost;
    var orderedItems = lineItems &&
        lineItems.map(function (lineItem) {
            return createProductObject(lineItem, lineItem.quantity, formatProductUrl, selfUrl);
        });
    var orderedPGItems = prescriptionGlassesLineItems.map(function (pgItem) {
        return createPrescriptionGlassesObject(pgItem, formatProductUrl, selfUrl);
    });
    return {
        '@type': 'Order',
        discount: calcPrice(discountTotal),
        orderNumber: orderNumber || '',
        orderTotal: calcPrice(originalTotal),
        shipmentCost: calcPrice(shippingCost),
        orderedItem: __spread(orderedItems, orderedPGItems) || [],
        paymentMethod: getPaymentMethodUrl(paymentMethod || ''),
    };
};
/**
 * Sets a new Action Object on the global SD actions storage on window
 */
var pushSdAction = function (action) {
    if (typeof window === 'undefined') {
        return;
    }
    if (!window.grandvision || !Array.isArray(window.grandvision.actions)) {
        window.grandvision = {
            actions: [],
        };
    }
    window.grandvision.actions.push(action);
    if (process.env.NODE_ENV !== 'production') {
        console.log('New Structured Data Action pushed to window.grandvision.actions: ', action);
    }
};
var getFacetLabel = function (key, facetLabels) {
    var labelObject = facetLabels.find(function (facetLabel) { return facetLabel.value === key; });
    return labelObject ? labelObject.label : '';
};
var FACET_BLACKLIST = ['variants', 'attributes', 'label', 'centAmount'];
var getSanitizedFacetName = function (facet, locale) {
    return facet
        .split('.')
        .filter(function (key) { return !(key === locale || FACET_BLACKLIST.includes(key)); })
        .join('');
};
function createPriceSpecification(product, vat) {
    if (!product) {
        console.warn('No product data found');
        return null;
    }
    var prices = getNestedProperty(product, 'prices', []).find(function (price) { return price.value.centAmount; });
    var standardPrice = getNestedProperty(prices, 'value.centAmount', 0);
    var discountedPrice = getNestedProperty(prices, 'discounted.value.centAmount', 0);
    var currency = getNestedProperty(prices, 'value.currencyCode', '');
    var vatRate = vat ? vat : 0;
    var priceSpecification = null;
    if (!standardPrice || vatRate === 0) {
        console.warn("Missing 'standardPrice' or 'vatRate'");
    }
    else {
        var _a = priceVatCalc(standardPrice, vatRate), priceExVat = _a.priceExVat, vatAmount = _a.vatAmount;
        if (!priceExVat || !vatAmount) {
            console.warn("Missing 'priceExVat' or 'vatAmount'");
            return null;
        }
        var standardPriceSpecification = {
            '@type': 'CompoundPriceSpecification',
            name: 'Price',
            price: calcPrice(standardPrice),
            priceCurrency: currency,
            valueAddedTaxIncluded: true,
            priceComponent: [
                {
                    '@type': 'UnitPriceSpecification',
                    name: 'Price excluding VAT',
                    price: calcPrice(priceExVat),
                    valueAddedTaxIncluded: false,
                },
                {
                    '@type': 'UnitPriceSpecification',
                    name: 'VAT',
                    price: calcPrice(vatAmount),
                    valueAddedTaxIncluded: true,
                },
            ],
        };
        priceSpecification = standardPriceSpecification;
        if (discountedPrice) {
            var _b = priceVatCalc(discountedPrice, vatRate), discountedPriceExVat = _b.priceExVat, discountedVatAmount = _b.vatAmount;
            var validFrom = getNestedProperty(prices || {}, 'discounted.discount.obj.validFrom', undefined);
            var validThrough = getNestedProperty(prices || {}, 'discounted.discount.obj.validUntil', undefined);
            var discountPriceSpecification = {
                '@type': 'CompoundPriceSpecification',
                name: 'Price',
                priceCurrency: currency,
                price: calcPrice(discountedPrice),
                valueAddedTaxIncluded: true,
                validFrom: validFrom,
                validThrough: validThrough,
                priceComponent: [
                    {
                        '@type': 'UnitPriceSpecification',
                        name: 'Price excluding VAT',
                        price: calcPrice(discountedPriceExVat),
                        valueAddedTaxIncluded: false,
                    },
                    {
                        '@type': 'UnitPriceSpecification',
                        name: 'VAT',
                        price: calcPrice(discountedVatAmount),
                        valueAddedTaxIncluded: true,
                    },
                ],
            };
            priceSpecification = discountPriceSpecification;
        }
    }
    return priceSpecification;
}

var isPrescriptionGlassesLineItem = function (lineItem) {
    return (lineItem === null || lineItem === void 0 ? void 0 : lineItem.type) === 'prescription-glasses-line-item';
};
var createCartAddAction = function (lineItem, formatProductUrl, quantity) {
    var _a, _b;
    var object = isPrescriptionGlassesLineItem(lineItem)
        ? createPrescriptionGlassesObject(lineItem, formatProductUrl)
        : createProductObject(lineItem, quantity, formatProductUrl);
    var action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Add,
        name: 'add_to_cart',
        object: object,
    };
    var category = ((_b = (_a = action === null || action === void 0 ? void 0 : action.object) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.toString()) || '';
    if (CommerceToolsApi.isAdditionalCartCosts(category)) {
        return undefined;
    }
    return action;
};
var createCartDeleteAction = function (lineItem, formatProductUrl, quantity) {
    var _a, _b;
    var object = isPrescriptionGlassesLineItem(lineItem)
        ? createPrescriptionGlassesObject(lineItem, formatProductUrl)
        : createProductObject(lineItem, quantity, formatProductUrl);
    var action = {
        '@context': 'https://schema.org',
        '@type': ActionType.Delete,
        name: 'remove_from_cart',
        object: object,
    };
    var category = ((_b = (_a = action === null || action === void 0 ? void 0 : action.object) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.toString()) || '';
    if (CommerceToolsApi.isAdditionalCartCosts(category)) {
        return undefined;
    }
    return action;
};
var createUpdateQuantityAction = function (lineItem, newQuantity, formatProductUrl) {
    var action;
    if (newQuantity > lineItem.quantity) {
        action = createCartAddAction(lineItem, formatProductUrl, newQuantity - lineItem.quantity);
    }
    else {
        action = createCartDeleteAction(lineItem, formatProductUrl, lineItem.quantity - newQuantity);
    }
    return action;
};
/**
 * Public methods - use these outside this package
 */
var addToCartSdAction = function (lineItems, formatProductUrl) {
    var e_1, _a;
    try {
        for (var lineItems_1 = __values(lineItems), lineItems_1_1 = lineItems_1.next(); !lineItems_1_1.done; lineItems_1_1 = lineItems_1.next()) {
            var lineItem = lineItems_1_1.value;
            var action = createCartAddAction(lineItem, formatProductUrl);
            action && pushSdAction(action);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (lineItems_1_1 && !lineItems_1_1.done && (_a = lineItems_1.return)) _a.call(lineItems_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
var updateQuantitySdAction = function (lineItem, newQuantity, formatProductUrl) {
    if (lineItem && newQuantity) {
        var action = createUpdateQuantityAction(lineItem, newQuantity, formatProductUrl);
        action && pushSdAction(action);
    }
};
var removeLineItemsSdAction = function (lineItems, formatProductUrl) {
    if (lineItems && lineItems.length) {
        lineItems.forEach(function (lineItem) {
            var action = createCartDeleteAction(lineItem, formatProductUrl);
            action && pushSdAction(action);
        });
    }
};

var CheckoutSteps;
(function (CheckoutSteps) {
    CheckoutSteps["Shipping"] = "shipping";
    CheckoutSteps["Overview"] = "overview";
    CheckoutSteps["Payment"] = "payment";
    CheckoutSteps["Completed"] = "completed";
})(CheckoutSteps || (CheckoutSteps = {}));
var getSdStepActionName = function (currentStep) {
    switch (currentStep) {
        case CheckoutSteps.Shipping:
            return 'order_start';
        case CheckoutSteps.Overview:
            return 'order_checkpoint_1';
        case CheckoutSteps.Payment:
            return 'order_checkpoint_2';
        case CheckoutSteps.Completed:
            return 'order_finished';
        default:
            return undefined;
    }
};
// Basic checkout action
var createCheckoutAction = function (name) {
    if (name === void 0) { name = ''; }
    return ({
        '@context': 'https://schema.org',
        '@type': ActionType.Action,
        name: name,
    });
};
var createCheckoutOrderAction = function (order, paymentMethod, formatProductUrl, selfUrl) {
    var object = createOrderObject(order, paymentMethod, formatProductUrl, selfUrl);
    return {
        '@context': 'https://schema.org',
        '@type': ActionType.Action,
        name: 'order_finished',
        object: object,
    };
};
/**
 * Public methods - use only these outside this package
 */
var checkoutStepSdAction = function (checkoutStep) {
    if (typeof checkoutStep === 'string') {
        var actionName = getSdStepActionName(checkoutStep);
        if (actionName) {
            var action = createCheckoutAction(actionName);
            pushSdAction(action);
        }
    }
};
var checkoutCompletedSdAction = function (order, paymentMethod, formatProductUrl, selfUrl) {
    if (order) {
        var action = createCheckoutOrderAction(order, paymentMethod, formatProductUrl, selfUrl);
        pushSdAction(action);
    }
};

var createSearchAction = function (currentFacets, facetLabels, priceRange, locale) {
    var filterList = currentFacets.map(function (currentFacet) {
        var facetLabel = getFacetLabel(currentFacet.facet, facetLabels);
        var propertyID = currentFacet.facet;
        var selectedValues = currentFacet.value.join(';');
        return {
            '@type': 'PropertyValue',
            name: facetLabel,
            propertyID: getSanitizedFacetName(propertyID, locale),
            value: selectedValues,
        };
    });
    if (priceRange && priceRange.facet && priceRange.value) {
        var prices = priceRange.value.match(/\d+/g);
        var minValue = (prices && +prices[0] / 100) || 0;
        var maxValue = (prices && +prices[1] / 100) || 0;
        var filter = {
            '@type': 'PropertyValue',
            name: getFacetLabel(priceRange.facet, facetLabels),
            propertyID: getSanitizedFacetName(priceRange.facet, locale),
            minValue: minValue,
            maxValue: maxValue,
        };
        filterList.push(filter);
    }
    return {
        '@context': 'https://schema.org',
        '@type': ActionType.Search,
        name: 'search',
        object: {
            '@type': 'ItemList',
            name: 'filters',
            itemListElement: filterList,
        },
    };
};
/**
 * Public methods - use these outside this package
 */
var searchSdAction = function (currentFacets, facetLabels, priceRange, locale) {
    var action = createSearchAction(currentFacets, facetLabels, priceRange, locale);
    pushSdAction(action);
};

var setUserObject = function (isLoggedIn) {
    if (isLoggedIn === void 0) { isLoggedIn = false; }
    if (typeof window === 'undefined') {
        return;
    }
    // Create empty user object if it not yet exists
    if (!window.grandvision || !window.grandvision.user) {
        window.grandvision = {
            user: {},
        };
    }
    window.grandvision.user = { loggedIn: isLoggedIn };
};

var createServiceObject = function (serviceType, audience, category, brand) {
    if (serviceType === void 0) { serviceType = 'WebPage'; }
    return (__assign(__assign(__assign({ '@context': 'https://schema.org', '@type': 'Service', serviceType: serviceType }, (audience && { audience: audience })), (category && { category: category })), (brand && { brand: brand })));
};
/*
 * Sets the global grandvision.service object.
 * For analytics purposes, be sure to use English values only.
 * Audience, category and brand may be supplied when relevant.
 * */
var setServiceObject = function (serviceType, audience, category, brand) {
    if (typeof window === 'undefined') {
        return;
    }
    if (!window.grandvision) {
        window.grandvision = {};
    }
    window.grandvision.service = createServiceObject(serviceType, audience, category, brand);
};

var JsonLd = function (thing) { return (createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: {
        __html: JSON.stringify(__assign({ '@context': 'http://schema.org' }, thing), null, 2),
    } })); };

var BreadcrumbList = function (_a) {
    var breadcrumbs = _a.breadcrumbs;
    var breadcrumbsList = breadcrumbs.map(function (crumb, index) {
        var crumbImage = { image: crumb.image };
        return {
            '@type': 'ListItem',
            position: index + 1,
            item: __assign({ '@id': crumb.url, name: crumb.name }, crumbImage),
        };
    });
    if (breadcrumbsList.length < 1) {
        return null;
    }
    var payload = {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: __spread(breadcrumbsList),
    };
    return (createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: JSON.stringify(payload) } }));
};

var initGA = function (trackerID, options) {
    var analyticsId = QueryString.parse(window.location.search.substring(1)).analyticsId;
    var GAOptions = __assign(__assign({}, options), (analyticsId && {
        gaOptions: {
            clientId: StringGuard.guard('analyticsId', analyticsId),
        },
    }));
    ReactGA.initialize(trackerID, GAOptions);
};
var logError = function (scope, message) {
    var Sentry = window.Sentry;
    console.error("[" + scope + "] " + message);
    if (Sentry) {
        Sentry.captureMessage("[" + scope + "] " + message);
    }
};
/**
 * when using adblocking the callback will never be hit. Creating an order will be then blocked.
 * Check if google tag manager is loaded else resolve.
 */
var getAnalyticsId = function () {
    return new Promise(function (resolve) {
        var ga = window.ga;
        var timeoutFlag = false;
        var gaTimeout = setTimeout(function () {
            logError('getAnalyticsId', 'ReactGa not loaded. Hit timeout.');
            timeoutFlag = true;
            resolve();
        }, 200);
        ReactGA.ga(function (tracker) {
            if (timeoutFlag) {
                return;
            }
            clearTimeout(gaTimeout);
            if (!tracker) {
                logError('getAnalyticsId', 'Analytics not initialized');
                resolve();
            }
            var clientId = tracker.get('clientId');
            if (clientId) {
                resolve(clientId);
            }
            else {
                logError('getAnalyticsId', 'No client id received from ReactGA tracker.');
                resolve();
            }
        });
        if (!ga || !ga.loaded) {
            clearTimeout(gaTimeout);
            logError('getAnalyticsId', 'ReactGa not loaded.');
            resolve();
        }
    });
};
var logPageView = function (pathName) {
    if (pathName) {
        ReactGA.set({ page: pathName });
        ReactGA.pageview(pathName);
    }
    else {
        var location_1 = window.location.pathname;
        var href = window.location.href.split('?')[1];
        if (href) {
            location_1 = location_1 + '?' + href;
        }
        ReactGA.set({ page: location_1 });
        ReactGA.pageview(location_1);
    }
};
var GoogleAnalytics = {
    initGA: initGA,
    getAnalyticsId: getAnalyticsId,
    logPageView: logPageView,
};

var GoogleTagManager = function (_a) {
    var gtmId = _a.gtmId, placement = _a.placement;
    var tags = (Array.isArray(gtmId) ? gtmId : [gtmId]).map(function (id) { return gtmParts({ id: id }); });
    if (placement === 'head') {
        return (createElement(Fragment, null,
            createElement("link", { rel: "preconnect", href: "https://www.googletagmanager.com" }),
            createElement("link", { rel: "preconnect", href: "https://www.google-analytics.com" }),
            tags.map(function (tag, i) { return (createElement(Fragment, { key: i }, tag.scriptAsReact())); })));
    }
    else if (placement === 'body') {
        return (createElement(Fragment, null, tags.map(function (tag, i) { return (createElement(Fragment, { key: i }, tag.noScriptAsReact())); })));
    }
    else {
        return null;
    }
};

var Organization = function (props) {
    return createElement(JsonLd, __assign({}, props));
};

var getOpeningHours = function (store) {
    var openingHours = [];
    var days = [
        { key: 'mondayOpenClose', label: 'Mo' },
        { key: 'tuesdayOpenClose', label: 'Tu' },
        { key: 'wednesdayOpenClose', label: 'We' },
        { key: 'thursdayOpenClose', label: 'Th' },
        { key: 'fridayOpenClose', label: 'Fr' },
        { key: 'saturdayOpenClose', label: 'Sa' },
        { key: 'sundayOpenClose', label: 'Su' },
    ];
    days.forEach(function (day) {
        store[day.key] &&
            store[day.key].forEach(function (hours) {
                return openingHours.push(day.label + " " + formatHour(hours.open) + "-" + formatHour(hours.close));
            });
    });
    return openingHours;
};

var optionalKey = function (key, value) {
    var _a;
    if (!value || value === {} || value === '') {
        return;
    }
    if (value instanceof Object && Object.values(value).every(function (v) { return v === ''; })) {
        return;
    }
    return _a = {}, _a[key] = value, _a;
};

var parseProductData = function (product, activeVariant, staticsUrl, locale) {
    var name = product.name.en || getAttrValue(activeVariant, 'brandModelCode');
    var imageUrl = (getNestedProperty(activeVariant, 'images', [])[0] || {}).url || '';
    var image = "" + staticsUrl + imageUrl + "?w=500&fm=jpeg";
    var description = getLocalizedAttrValue(activeVariant, 'description', locale);
    var brand = getAttrValue(activeVariant, 'brand');
    var firstCategory = getNestedProperty(product, 'categories')[0] || '';
    var category = getNestedProperty(firstCategory, "obj.name.en", '');
    var sku = activeVariant.sku || '';
    return {
        name: name,
        image: image,
        description: description,
        brand: brand,
        category: category,
        sku: sku,
    };
};

var Product = function (_a) {
    var product = _a.product, activeSKU = _a.activeSKU, staticsUrl = _a.staticsUrl, url = _a.url, _b = _a.locale, locale = _b === void 0 ? 'en' : _b, extra = _a.extra;
    var activeVariant = __spread([product.masterVariant], product.variants).find(function (variant) { return variant.sku === activeSKU; }) ||
        product.masterVariant;
    var vat = getNestedProperty(product, 'taxCategory.obj.rates', []).find(function (rate) { return rate.includedInPrice; });
    var offers = [
        {
            '@type': 'Offer',
            priceSpecification: createPriceSpecification(activeVariant, vat.amount),
        },
    ];
    var _c = parseProductData(product, activeVariant, staticsUrl, locale), name = _c.name, image = _c.image, description = _c.description, brand = _c.brand, category = _c.category, sku = _c.sku;
    var payload = __assign(__assign(__assign(__assign(__assign({ '@type': 'Product', '@id': url + "#product", url: url,
        sku: sku,
        image: image, name: (name && String(name)) || sku }, optionalKey('description', description)), optionalKey('brand', brand)), optionalKey('category', category)), optionalKey('offers', offers)), extra);
    return createElement(JsonLd, __assign({}, payload));
};

var Offer = function (_a) {
    var rest = __rest(_a, []);
    var payload = __assign({ '@type': 'Offer' }, rest);
    return createElement(JsonLd, __assign({}, payload));
};

// For now we are using the masterVariant
var ProductsSd = function (_a) {
    var items = _a.items, formatProductUrl = _a.formatProductUrl, staticsUrl = _a.staticsUrl, locale = _a.locale, originUrl = _a.originUrl;
    var productList = items.map(function (product, index) {
        var sku = product.masterVariant.sku;
        var productType = product && product.productType && product.productType.obj
            ? product.productType.obj.name
            : '';
        var slug = product.slug;
        var productUrl = "" + (originUrl || '') + formatProductUrl({
            productType: productType,
            sku: sku,
            slug: slug,
        });
        var activeVariant = product.masterVariant;
        var _a = parseProductData(product, activeVariant, staticsUrl, locale), name = _a.name, description = _a.description, brand = _a.brand, category = _a.category;
        var vat = getNestedProperty(product, 'taxCategory.obj.rates', []).find(function (rate) { return rate.includedInPrice; });
        var offers = [
            {
                '@type': 'Offer',
                priceSpecification: createPriceSpecification(activeVariant, vat.amount),
            },
        ];
        var listItemContent = __assign(__assign(__assign(__assign(__assign({ '@type': 'Product', '@id': productUrl + "#product", name: (name && String(name)) || sku, url: productUrl }, optionalKey('description', description)), optionalKey('brand', brand)), optionalKey('category', category)), optionalKey('offers', offers)), { sku: sku });
        return {
            '@type': 'ListItem',
            position: index + 1,
            item: listItemContent,
        };
    });
    var payload = {
        '@type': 'ItemList',
        itemListElement: productList,
    };
    return createElement(JsonLd, __assign({}, payload));
};

var Store = function (_a) {
    var store = _a.store, url = _a.url;
    var cleanUrl = url.split('?')[0];
    var payload = {
        '@type': 'Store',
        '@id': cleanUrl + "/" + store.slug + "#store",
        url: cleanUrl + "/" + store.slug,
        name: store.storeName,
        description: store.metaDescription,
        email: store.storeEmailAddress,
        image: store.storeDetailImage,
        address: [
            {
                '@type': 'PostalAddress',
                streetAddress: store.streetName + " " + store.streetNumber,
                postalCode: store.postalCode,
                addressLocality: store.town,
                addressCountry: store.country,
            },
        ],
        contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'sales contact point',
            telephone: store.Phone1,
        },
        openingHours: getOpeningHours(store),
    };
    return createElement(JsonLd, __assign({}, payload));
};

var Stores = function (_a) {
    var stores = _a.stores, url = _a.url;
    var cleanUrl = url.split('?')[0];
    var storeList = stores.map(function (store, index) { return ({
        '@type': 'ListItem',
        position: index + 1,
        item: {
            '@type': 'Store',
            '@id': cleanUrl + "/" + store.slug + "#store",
            // TODO: replace as soon as we have a detail page URL available
            url: cleanUrl + "/" + store.slug,
            name: store.storeName,
            email: store.storeEmailAddress,
            image: store.storeDetailImage,
            address: [
                {
                    '@type': 'PostalAddress',
                    streetAddress: store.streetName + " " + store.streetNumber,
                    postalCode: store.postalCode,
                    addressLocality: store.town,
                    addressCountry: store.country,
                },
            ],
            contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'sales contact point',
                telephone: store.Phone1,
            },
            openingHours: getOpeningHours(store),
        },
    }); });
    var payload = {
        '@type': 'ItemList',
        itemListElement: storeList,
    };
    return createElement(JsonLd, __assign({}, payload));
};

var WebPage = function (_a) {
    var pageType = _a.pageType, url = _a.url, rest = __rest(_a, ["pageType", "url"]);
    var cleanUrl = url.split('?')[0];
    var payload = __assign(__assign({ '@type': 'WebPage', '@id': cleanUrl, additionalType: "https://grandvision.com/#/PageType/" + pageType }, rest), { url: cleanUrl });
    return createElement(JsonLd, __assign({}, payload));
};

var EmptyScript = function () { return createElement(Fragment, null); };
var nonEmptyString = constrain(Type.string, [Constraint.string.notEmpty]);
var sentryConfigSpec = Type.object({
    dsn: nonEmptyString,
    environment: either(Type.literal({ testing: 1 }), Type.literal({ acceptance: 1 }), Type.literal({ production: 1 })),
    release: nonEmptyString,
});
var SentryScript = function (props) {
    if (!version) {
        console.error("No version for Sentry received from package.json. Received: " + version);
        return createElement(EmptyScript, null);
    }
    var verificationResult = verify(sentryConfigSpec, props);
    if (verificationResult.err) {
        if (process.env.NODE_ENV === 'production') {
            console.error(verificationResult.err);
        }
        return createElement(EmptyScript, null);
    }
    return (createElement(Fragment, null,
        createElement("link", { rel: "preconnect", href: "https://browser.sentry-cdn.com" }),
        createElement("script", { src: "https://browser.sentry-cdn.com/" + version + "/bundle.min.js" }),
        createElement("script", { dangerouslySetInnerHTML: {
                __html: "Sentry.init(" + JSON.stringify(props) + ")",
            } })));
};

function withSentry(Component$1) {
    var wrappedName = Component$1.displayName || Component$1.name || 'Component';
    var Wrapper = /** @class */ (function (_super) {
        __extends(Wrapper, _super);
        function Wrapper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Wrapper.prototype.componentDidCatch = function (error, errorInfo) {
            var Sentry = window.Sentry;
            if (Sentry) {
                Sentry.withScope(function (scope) {
                    Object.keys(errorInfo).forEach(function (key) {
                        scope.setExtra(key, errorInfo[key]);
                    });
                });
                Sentry.captureException(error);
            }
        };
        Wrapper.prototype.render = function () {
            return createElement(Component$1, __assign({}, this.props));
        };
        Wrapper.displayName = "withSentry(" + wrappedName + ")";
        return Wrapper;
    }(Component));
    return hoistNonReactStatic(Wrapper, Component$1);
}

var ALGOLIA_ANALYTICS_STORAGE_KEY = 'algoliaAnalyticsData';
var useAlgoliaAnalytics = function () {
    var _a = __read(useLocalStorage(ALGOLIA_ANALYTICS_STORAGE_KEY, {
        queryId: undefined,
        searchIndex: '',
    }), 2), data = _a[0], setData = _a[1];
    var saveData = React__default.useCallback(function (newData) {
        setData(newData);
    }, []);
    var clearQueryId = React__default.useCallback(function () {
        setData(function (data) {
            if (data === void 0) { data = {}; }
            return (__assign(__assign({}, data), { queryId: undefined }));
        });
    }, [data]);
    var handleConversionEvent$1 = React__default.useCallback(function (objectId, queryId) {
        if (data) {
            handleConversionEvent({
                objectIds: objectId,
                searchIndex: data.searchIndex,
                queryId: queryId,
            });
        }
    }, [data]);
    return { algoliaAnalyticsData: data, saveData: saveData, clearQueryId: clearQueryId, handleConversionEvent: handleConversionEvent$1 };
};

var AlgoliaAnalytics = function (_a) {
    var children = _a.children, searchResults = _a.searchResults;
    if (!children) {
        return null;
    }
    var saveData = useAlgoliaAnalytics().saveData;
    var queryID = searchResults.queryID, index = searchResults.index;
    var handleSearchAnalytics = function (objectId, position, eventName) { return function () {
        var eventData = {
            eventName: eventName || AlgoliaAnalyticsEvents.SearchResultClicked,
            objectIds: objectId,
            searchIndex: index,
        };
        if (queryID && position) {
            saveData({ queryId: queryID, searchIndex: index });
            clickedObjectIdsAfterSearch(__assign(__assign({}, eventData), { queryId: queryID, positions: position }));
        }
        else {
            clickedObjectIds(eventData);
        }
    }; };
    return children(handleSearchAnalytics);
};
var AlgoliaAnalytics$1 = connectStateResults(AlgoliaAnalytics);

var Optimizely = function (_a) {
    var projectId = _a.projectId;
    if (!projectId) {
        console.error('No project ID for Optimizely found');
        return null;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("link", { rel: "preconnect", href: "https://cdn.optimizely.com" }),
        React__default.createElement("link", { rel: "preconnect", href: "https://logx.optimizely.com" }),
        React__default.createElement("script", { src: "https://cdn.optimizely.com/js/" + projectId + ".js" })));
};

/**
 * Analytics Module
 *
 * Contains all components related to website analytics
 *
 * @grandvision/analytics
 */
SagaRegistry.register('analytics', sagas);

export { ALGOLIA_ANALYTICS_STORAGE_KEY, ActionType, AlgoliaAnalytics$1 as AlgoliaAnalytics, AlgoliaAnalyticsHelpers, types as AlgoliaAnalyticsTypes, BreadcrumbList, CheckoutSteps, index as DataLayer, GoogleAnalytics, GoogleTagManager, JsonLd, Offer, Optimizely, Organization, Product, ProductsSd, SentryScript, Store, Stores, ldJson as StructuredDataTypes, WebPage, addToCartSdAction, calcPrice, checkoutCompletedSdAction, checkoutStepSdAction, createCartAddAction, createCartDeleteAction, createCheckoutAction, createCheckoutOrderAction, createOfferObject, createOrderObject, createPrescriptionGlassesObject, createPrescriptionGlassesOffer, createPrescriptionGlassesPrice, createPriceSpecification, createProductObject, createSearchAction, createUpdateQuantityAction, getFacetLabel, getPaymentMethodUrl, getSanitizedFacetName, getSdStepActionName, getUrlInfo, priceVatCalc, pushSdAction, removeLineItemsSdAction, searchSdAction, setServiceObject, setUserObject, updateQuantitySdAction, useAlgoliaAnalytics, withSentry };
//# sourceMappingURL=index.es.js.map
